import router from '../services/router_service';
import signinController from '../controllers/signin_controller';

router.on('route:signin', signinController);
